import { PRE_CHAT_FORM_FIELD_LABELS } from '~/features/preChatForms/constants'
import {
  EPreChatFormFieldKeys,
  TGuestPreChatFormField,
} from '~/features/preChatForms/models'

const getPreChatFormFieldBaseLabel = (field: TGuestPreChatFormField) =>
  PRE_CHAT_FORM_FIELD_LABELS[field[EPreChatFormFieldKeys.fieldMapping]] ??
  field[EPreChatFormFieldKeys.displayName]

export const getPreChatFormFieldLabel = (field: TGuestPreChatFormField) => {
  const baseLabel = getPreChatFormFieldBaseLabel(field)

  if (!field[EPreChatFormFieldKeys.required]) {
    return `${baseLabel} (optional)`
  }

  return baseLabel
}

export const getPreChatFormFieldPlaceholder = (field: TGuestPreChatFormField) =>
  getPreChatFormFieldBaseLabel(field)
